module.exports = __webpack_public_path__ + "assets/img/jianmei--blue.713266ee.png";